import { render, staticRenderFns } from "./PopupUpdate.vue?vue&type=template&id=a5930bb4&scoped=true&"
import script from "./PopupUpdate.vue?vue&type=script&lang=js&"
export * from "./PopupUpdate.vue?vue&type=script&lang=js&"
import style0 from "./PopupUpdate.vue?vue&type=style&index=0&id=a5930bb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5930bb4",
  null
  
)

export default component.exports